module.exports = __webpack_public_path__ + "img/seal-img.171ce834.png";